
/* injects from baggage-loader */

'use strict';

import ProjectInvestmentWizardController from './projectinvestmentwizard.controller';
import ProjectInvestmentWizardTemplate from './projectinvestmentwizard.html';

export default class ProjectInvestmentWizardComponent {
		constructor() {
				this.templateUrl = ProjectInvestmentWizardTemplate;
				this.controller = ProjectInvestmentWizardController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					profile: '<',
					project: '<' 
				};
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/projectInvestmentWizard/projectinvestmentwizard.component.js